import React, { useState } from 'react';
import { ExternalLink } from '../router';
import { BOOKING_URL, CONTACT_EMAIL } from '../links';
import { useOpenNewsletter } from '../newsletter';
import SocialLinks from '../components/SocialLinks';
import GhlFormModal, { GHL_FORMS } from '../components/GhlFormModal';

const Contact: React.FC = () => {
  const openNewsletter = useOpenNewsletter();
  const [isFormOpen, setIsFormOpen] = useState(false);

  return (
    <section className="section page-hero">
      <div className="container container--narrow contact-page">
        <h1>Contact</h1>
        <p className="lead">Have a question before booking? Reach me directly.</p>
        <p className="contact-page__email">
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
        </p>
        <button className="btn btn-primary" onClick={() => setIsFormOpen(true)}>
          Send Me a Message
        </button>
        <ExternalLink href={BOOKING_URL} className="btn btn-primary">
          Book a Complimentary Performance Strategy Session
        </ExternalLink>
        <SocialLinks className="social-links--dark" />
        <button className="btn btn-primary" onClick={openNewsletter}>
          Subscribe to the KinezioLetter
        </button>
      </div>
      <GhlFormModal
        isOpen={isFormOpen}
        onClose={() => setIsFormOpen(false)}
        form={GHL_FORMS.enquiry}
        title="Send Me a Message"
        intro="Tell me a little about what you need, and I'll reply within 2 working days."
      />
    </section>
  );
};

export default Contact;
